var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question-item question-completion" }, [
    _c("div", { staticClass: "title-box" }, [
      _c("span", { staticClass: "line-name" }, [_vm._v("答案")]),
      !_vm.readOnly
        ? _c("span", { staticClass: "line-dec" }, [
            _vm._v("请输入每个填空的答案"),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "completion option" }, [
      _c(
        "div",
        { staticClass: "option-content" },
        _vm._l(_vm.optionsCopy, function (item, index) {
          return _c("div", { key: index, staticClass: "option-item" }, [
            _c("div", { staticClass: "item-line1" }, [
              _c("div", { staticClass: "item-order item-order-completion" }, [
                _c("span", [_vm._v(_vm._s(index + 1))]),
              ]),
              _c(
                "div",
                { staticClass: "item-text-completion" },
                [
                  !_vm.readOnly
                    ? _c("el-input", {
                        attrs: {
                          placeholder: "请输入内容",
                          maxlength: _vm.inputlength,
                        },
                        model: {
                          value: item["exam_questions_options.name"],
                          callback: function ($$v) {
                            _vm.$set(item, "exam_questions_options.name", $$v)
                          },
                          expression: "item['exam_questions_options.name']",
                        },
                      })
                    : _c("el-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          autosize: _vm.readOnly,
                          placeholder: "请输入内容",
                          type: "textarea",
                        },
                        model: {
                          value: item["exam_questions_options.name"],
                          callback: function ($$v) {
                            _vm.$set(item, "exam_questions_options.name", $$v)
                          },
                          expression: "item['exam_questions_options.name']",
                        },
                      }),
                ],
                1
              ),
              !_vm.readOnly
                ? _c("div", { staticClass: "item-del-completion" }, [
                    _c("i", {
                      staticClass: "el-icon-error",
                      on: {
                        click: function ($event) {
                          return _vm.delOption(item, index)
                        },
                      },
                    }),
                    _c("i", {
                      staticClass: "el-icon-top",
                      on: {
                        click: function ($event) {
                          return _vm.upOption(item, index)
                        },
                      },
                    }),
                    _c("i", {
                      staticClass: "el-icon-bottom",
                      on: {
                        click: function ($event) {
                          return _vm.downOption(item, index)
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
          ])
        }),
        0
      ),
      !_vm.readOnly
        ? _c(
            "div",
            { staticClass: "option-add-completion" },
            [
              _c(
                "DsfButton",
                {
                  attrs: { type: "plain", icon: "add" },
                  on: { click: _vm.addOption },
                },
                [_vm._v("添加填空")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }